import medicineLoadError from "../medicines-load/medicine-load-error/MedicineLoadError";
import medicineList from "../medicines-load/medicine-list/MedicineList.vue";
import vademecumService from "../../services/vademecum/Vademecum";
import { StorageService } from "../../services/StorageService.js";
import i18n from '../../i18n/index';
import fileLog from "../../services/file-log/FileLog";
import vademecum from '../../services/vademecum/Vademecum';

export default {
  components: { medicineLoadError, medicineList },
  data: () => ({

    logData: [],
    total: 0,
    pagination: {},
    newLoad: false,
    hideList: false,
    search: "",
    uploads: [],
    upload: { fileLoadDetails: [] },
    attachment: { name: "" },
    user: {},
    loading: false,
    headers: [
      {
        text: i18n.t('headers.file-name'),
        sortable: false,
        value: "plu"
      },
      {
        sortable: false,
        text: i18n.t('headers.user'),
        value: "name"
      },
      {
        sortable: false,
        text: i18n.t('headers.status'),
        value: "isWatched",
        align: "left"
      },
      {
        sortable: false,
        text: i18n.t('headers.date'),
        value: "isApplicable",
        align: "left"
      }
    ]
  }),
  props: {},
  watch: {
    pagination: {
      handler() {
        this.getFileLog();
      },
      deep: true
    }
  },
  created() {
    this.getFileLog();
  },

  methods: {
    
    onRowClick(item) {
      this.$emit("row-click", item);
    },

    getFileLog() {
      const { page, rowsPerPage } = this.pagination;
      fileLog.getLog(page - 1, rowsPerPage).then(response => {
        this.logData = response.data[0];
        this.total = response.data[1];
      });
    },

    handleFilePondInit: function () {
      // FilePond instance methods are available on `this.$refs.pond`
      /* eslint-disable */
      console.log('FilePond has initialized');
    },

    handleUpload(upload) {
      this.upload = upload;
      this.hideList = true;
    },
    closeUpload() {
      this.newLoad = false;
      this.hideList = false;
      this.upload = { fileLoadDetails: [] };
      this.attachment = { name: "" };
      this.$refs.medicineList.getFileLog();
    },
    openFileChooser() {
      this.$refs.file.click();
      this.loading = true;
    },

    handleFile() {
      this.attachment = this.$refs.file.files[0];
      if (!this.attachment.length) {
      }
      vademecumService.uploadVademecum(this.attachment).then(response => {
        console.log(vademecumService)

        if (response.status == 200) {
          this.closeUpload();
          this.$refs.medicineList.getFileLog();
        }
        this.$notify({
          group: "app",
          type: "success",
          text: i18n.t('processing-the-file')
        });
        this.loading = false;
        this.$refs.medicineList.getFileLog();
      })
        .catch(error => {
          console.log('error', error.response);
          this.loading = false;
        })
    },
    getUserName() {
      const user = StorageService.getUserData();
      this.user = user.id;
    },
    timer() {
      setTimeout(function () {
        this.loading = true
      }.bind(this), 3000);
    }
  }
};